import { exactlyConfig } from '@1delta/data-sdk'
import { Call } from '../../../utils/multicall'

/**
 * Build the user-data call set for Exactly: a SINGLE
 * `Previewer.exactly(account)` call returns every market's floating position,
 * all fixed deposit/borrow positions (with live `previewValue` = withdraw-now /
 * repay-now value incl. early-exit discount and overdue penalty), and the
 * per-market `isCollateral` flag — no per-market fan-out needed.
 */
export const buildExactlyUserCall = (
  chainId: string,
  _lender: string,
  account: string,
): Call[] => {
  const cfg = exactlyConfig()?.[chainId]
  if (!cfg?.previewer) return []
  return [{ address: cfg.previewer, name: 'exactly', params: [account] }]
}
